module.exports = __webpack_public_path__ + "img/s3-1.850432e7.jpg";